import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-tax-data',
  templateUrl: './tax-data.component.html',
  styleUrls: ['./tax-data.component.scss']
})
export class TaxDataComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() error: boolean;
  @Input() disableConditions = false;

  constructor() {}

  ngOnInit(): void {
    const ustPflichtig = this.inputForm.get('ustPflichtig');
    if (ustPflichtig && ustPflichtig.value) {
      this.taxMandatoryChanged({ value: true }, true);
    }
  }

  taxMandatoryChanged(event: any, init?: boolean) {
    const ustNr = this.inputForm.get('ustNr');
    const taxNr = this.inputForm.get('taxNr');
    if (event.value) {
      if (!init) {
        ustNr.patchValue('');
        taxNr.patchValue('');
      }
      ustNr.enable();
      ustNr.markAsTouched();
      taxNr.enable();
      taxNr.markAsTouched();
    } else {
      ustNr.clearValidators();
      ustNr.patchValue('');
      ustNr.markAsTouched();
      taxNr.patchValue('');
      taxNr.markAsTouched();
    }
  }

  checkIfMandatory() {
    return this.inputForm.get('ustPflichtig').value;
  }
}
